import {ControlledSelect, ControlledToggle, Kpi} from '@hm/fundamental'

import {useRiskSurveyTranslation} from '../../hooks'

type ReportFiltersProps = {
  plantFilter: string[]
  onPlantFilterChange: (values: string[]) => void
  plantOptions: {value: string; label: string}[]
  kpiTotal: number
  kpiNew: number
  kpiPending: number
  kpiInProgress: number
  kpiCompleted: number
  kpiRejected: number
  includeArchived: boolean
  onIncludeArchivedChange: (value: boolean) => void
}

export const ReportFilters = ({
  plantFilter,
  onPlantFilterChange,
  plantOptions,
  kpiTotal,
  kpiNew,
  kpiPending,
  kpiInProgress,
  kpiCompleted,
  kpiRejected,
  includeArchived,
  onIncludeArchivedChange
}: ReportFiltersProps) => {
  const {t} = useRiskSurveyTranslation()

  return (
    <div className="flex gap-4 flex-wrap items-center">
      <div className="min-w-[200px]">
        <ControlledSelect
          name="plantFilter"
          label={t('overview.plantFilter')}
          value={plantFilter[0] ?? ''}
          onChange={(value) => onPlantFilterChange(value ? [String(value)] : [])}
          values={[{value: '', label: t('common.all')}, ...plantOptions]}
          data-cy="report-plant-filter"
        />
      </div>
      <div className="flex-1" />
      <div className="flex gap-4 items-center flex-wrap">
        <div className="bg-neutral_faded_10 py-1 px-3 rounded">
          <Kpi value={kpiTotal} label={t('overview.totalRias')} size="xsmall" />
        </div>
        <div className="bg-neutral_faded_10 py-1 px-3 rounded border-l-[3px] border-info">
          <Kpi
            value={<span className="text-info">{kpiNew}</span>}
            label={t('status.New')}
            size="xsmall"
          />
        </div>
        <div className="bg-neutral_faded_10 py-1 px-3 rounded border-l-[3px] border-warning">
          <Kpi
            value={<span className="text-warning">{kpiPending}</span>}
            label={t('status.Pending')}
            size="xsmall"
          />
        </div>
        <div className="bg-neutral_faded_10 py-1 px-3 rounded border-l-[3px] border-primary">
          <Kpi
            value={<span className="text-primary">{kpiInProgress}</span>}
            label={t('status.InProgress')}
            size="xsmall"
          />
        </div>
        <div className="bg-neutral_faded_10 py-1 px-3 rounded border-l-[3px] border-positive">
          <Kpi
            value={<span className="text-positive">{kpiCompleted}</span>}
            label={t('status.Completed')}
            size="xsmall"
          />
        </div>
        <div className="bg-neutral_faded_10 py-1 px-3 rounded border-l-[3px] border-negative">
          <Kpi
            value={<span className="text-negative">{kpiRejected}</span>}
            label={t('status.Rejected')}
            size="xsmall"
          />
        </div>
      </div>
      <div className="flex-1" />
      <ControlledToggle
        name="includeArchived"
        label={t('archive.showArchived')}
        checked={includeArchived}
        onChange={(e) => onIncludeArchivedChange(e.target.checked)}
        data-cy="show-archived-toggle"
      />
    </div>
  )
}
